'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');

var _components = require('../../components');
var _containers = require('../../containers');
var _SliderCart = require('../../components/ProjectDetailedInfo/SliderCart/SliderCart');var _SliderCart2 = _interopRequireDefault(_SliderCart);


var _projectProperties = require('../../redux/modules/projectProperties');
var _getLocalizedData3 = require('../../utils/getLocalizedData');var _getLocalizedData4 = _interopRequireDefault(_getLocalizedData3);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);

var _ProjectPropertiesContainer = require('./ProjectPropertiesContainer.scss');var styles = _interopRequireWildcard(_ProjectPropertiesContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Redux
var ProjectPropertiesContainer = function (_Component) {_inherits(ProjectPropertiesContainer, _Component);function ProjectPropertiesContainer() {var _temp, _this, _ret;_classCallCheck(this, ProjectPropertiesContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      images: [],
      isOpen: false }, _this.












    handleClick = function () {
      _this.setState(function (prevState) {return { isOpen: !prevState.isOpen };});
    }, _this.

    renderListItem = function (data, idx) {var _this$props =
      _this.props,isMobile = _this$props.isMobile,locale = _this$props.locale,translate = _this$props.translate,isRtl = _this$props.isRtl;var
      isOpen = _this.state.isOpen;var _getLocalizedData =

      (0, _getLocalizedData4.default)(data.name, _this.props.locale),name = _getLocalizedData.result;var _getLocalizedData2 =
      (0, _getLocalizedData4.default)(data.summary, _this.props.locale),summary = _getLocalizedData2.result;

      return !isMobile || isOpen || idx <= 1 ?
      _react2.default.createElement('div', { key: data.id },
        _react2.default.createElement(_components.ProjectPropertyCell, {
          key: data.id,
          isMobile: isMobile,
          locale: locale,
          translate: translate,
          isRtl: isRtl,
          image: data.plan_image,
          images: data.plan_images,
          price: data.start_price,
          exactPrice: data.exact_price,
          area: data.area,
          rooms: data.rooms,
          currency: _this.props.currency,
          name: name,
          summary: summary,
          type: data.property_type,
          openLightbox: function openLightbox() {
            if (data.plan_images) {
              _this.setState({ images: data.plan_images });
              _this.props.openLightbox();
            }
          } })) :


      null;
    }, _this.

    renderLightbox = function () {return (
        _react2.default.createElement(_containers.OMLightbox, {
          currentImage: 0,
          images: _this.state.images,
          isOpen: _this.props.isLightboxOpen,
          hideLightbox: _this.props.hideLightbox,
          translate: _this.props.translate('propertyDetails'),
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl }));}, _temp), _possibleConstructorReturn(_this, _ret);}ProjectPropertiesContainer.prototype.componentWillMount = function componentWillMount() {this.props.receiveProjectProperties(this.props.projectId);};ProjectPropertiesContainer.prototype.componentWillUnmount = function componentWillUnmount() {if (this.props.isLightboxOpen) {this.props.hideLightbox();}};ProjectPropertiesContainer.prototype.



  render = function render() {var _props =
    this.props,projectProperties = _props.projectProperties,loading = _props.loading,isMobile = _props.isMobile,translate = _props.translate;var
    isOpen = this.state.isOpen;

    if (loading || !projectProperties.length) {return null;}

    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        isMobile ?
        _react2.default.createElement('div', { className: styles.projectPropertiesWrapper },
          _react2.default.createElement('p', { className: styles.title }, this.props.title),
          projectProperties.map(this.renderListItem),
          projectProperties.length > 2 && isMobile &&
          _react2.default.createElement('div', { className: styles.showAll, onClick: this.handleClick },
            _react2.default.createElement('i', { className: 'icon icon-arrow-' + (isOpen ? 'up' : 'down') }),
            _react2.default.createElement('p', null, translate('propertyDetails', isOpen ? 'hideDescription' : 'seeAll')))) :



        _react2.default.createElement(_SliderCart2.default, {
            title: this.props.title,
            isShowNavigation: projectProperties.length >= 3 || isMobile },

          projectProperties.map(this.renderListItem)),


        this.renderLightbox()));


  };return ProjectPropertiesContainer;}(_react.Component);


ProjectPropertiesContainer.propTypes = {
  projectId: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  title: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  projectProperties: _propTypes2.default.array,
  receiveProjectProperties: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  isLightboxOpen: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    loading: state.projectProperties.loading,
    projectProperties: state.projectProperties.data || [],
    isLightboxOpen: state.projectProperties.isProjectPropertyLightboxOpen };};


var mapDispatchToProps = {
  receiveProjectProperties: _projectProperties.receiveProjectProperties,
  openLightbox: _projectProperties.openProjectPropertyLightbox,
  hideLightbox: _projectProperties.hideProjectPropertyLightbox };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
ProjectPropertiesContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectPropertiesContainer/ProjectPropertiesContainer.js
// module id = 3006
// module chunks = 0